import { addToast } from '@mobi/component-library/Feedback/Toast'
import { toastIds } from '@mobi/account/Utils/constants'

export const FeedbackWithdrawalChannelChange = () => {
  addToast({
    id: toastIds.withdrawalChannelChange,
    isDismissable: true,
    title: 'Your withdrawal request may take up to two days to reach your bank account.',
    icon: 'info',
    timeoutMs: 6_000, // 6s
  })
}
